<template>
  <div class="input-group">
    <div class="captcha">
        <img class="u-mb-sm"
          v-if="imageUrl"
          :src="imageUrl"><br>
        <a class="btn btn--sm"
          v-if="audioUrl"
          @click.prevent="playAudioCaptcha"
          :href="audioUrl">
          <span class="icon icon--xl icon-audio--white"></span>
          <span class="u-hidden-visually">{{ gettext('Audio captcha: please listen and type the letters you hear') }}</span>
        </a>
        <audio v-if="audioUrl" ref="audioEl">
          <source :src="audioUrl" ref="audioElSrc" type="audio/wav">
          <p><a :href="audioUrl">{{ gettext('Download audio captcha') }}</a></p> <!-- fallback -->
        </audio>
        <button class="btn btn--sm"
          @click.prevent="refresh"
          type="button"> <!-- type="submit" is default; needs type="button" to prevent it from attempting to post form data -->
          {{ gettext('Refresh') }}
        </button>
    </div>
    <label for="captcha">
        {{ gettext('Enter the letters and numbers you see in the image') }}
    </label
    ><input
      id="captcha"
      class="input--short"
      v-model="response"
      type="text">
    <input
      :value="captchaKey"
      type="hidden">
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Captcha',

  props: {
    refreshUrl: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      captchaKey: '',
      imageUrl: '',
      audioUrl: '',
      response: '',
    }
  },

  created() {
    this.refresh()
  },

  methods: {
    refresh() {
      axios.get(this.refreshUrl, {headers: {'X-Requested-With': 'XMLHttpRequest'}}).then(
        (success) => {
          this.captchaKey = success.data['key']
          this.imageUrl = success.data['image_url']
          this.audioUrl = success.data['audio_url']
          this.response = ''
        },
        (error) => {
          // Report it to Sentry
          if (window.Raven) { window.Raven.captureException(error) }
          // Try again - not sure what else to do
          window.setTimeout(this.refresh, 3000)
        }
      )
    },
    playAudioCaptcha() {
      if (!this.$refs.audioEl.paused) {
        this.$refs.audioEl.pause()
      }
      else {
        this.$refs.audioEl.play()
      }
    },
    reloadAudioSrc(newSrc) {
      this.$refs.audioElSrc.src = newSrc
      this.$refs.audioEl.load()
    },
  },
  
  watch: {
    audioUrl(onChange) {
      this.reloadAudioSrc(onChange)
    }
  }
}
</script>
